import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntGovernment } from "../../../../models/handBooks/government";

import { useTranslation } from "react-i18next";
import { AddGovernmentModal } from "./AddGovernmentModal";
import { useGovernment } from "./useGovernments";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { BasicHbFilter } from "../../../../models/filters/basicHbFilter";
import { useLazyGetGovernmentListQuery } from "../../../../redux/api/handBooksApi/governmentApi";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name,
}

export const Governments = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = useForm();
  const { t } = useTranslation();
  const [selectedGovernment, setSelectedGovernment] = useState<EntGovernment>(new EntGovernment());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddGovernment, onEditGovernment, onDeleteGovernment } = useGovernment(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetGovernmentListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	setCurrentPage
  } = useGetDataOnScroll<EntGovernment, BasicHbFilter>({
	initialFilter: new BasicHbFilter(),
	query: getData
  });

  const openAddModal = (item: EntGovernment) => {
	setSelectedGovernment(item);
	setShowModal(true);
  };

  const setEntityFromFields = (): BasicHbFilter => {
	let item: BasicHbFilter = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.page = 1;
	return item;
  };

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  };

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('general.alias') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 5 }>
			  <Spin
				spinning={ fetching }
				style={ {
				  width: '100%',
				  height: '180px',
				  display: 'flex',
				  alignItems: 'center',
				  justifyContent: 'center',
				} }
			  />
			</th>
		  </tr>
		) : (
		  <></>
		) }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ item?.alias }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button
					  className="btn_edit"
					  onClick={ () => {
						openAddModal(item)
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <EditOutlined/> }
					/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button
					  className="btn_edit"
					  danger
					  onClick={ () => {
						onDeleteGovernment(item)
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <DeleteOutlined/> }
					/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.governments') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntGovernment())
		} }>
		  { t('handbooks.governments.add_government') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick } onReset={ () => {
		  clearFields();
		  searchHandleClick();
		} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddGovernmentModal
		government={ selectedGovernment }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedGovernment.id !== null ? onEditGovernment : onAddGovernment }
	  />
	  { contextHolder }
	</>
  );
};
